"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "crespina-lorenzana": {
    "d081689b": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "skipSearch": false
    }],
    "belvedere": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b1057225": [{
      "hkey": "69c3c89d",
      "slug": "tripalle-botteghino",
      "name": "Tripalle-Botteghino",
      "primary": true,
      "skipSearch": false
    }],
    "botteghino": [{
      "hkey": "69c3c89d",
      "slug": "tripalle-botteghino",
      "name": "Tripalle-Botteghino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "crespina-lorenzana"
    }],
    "1f2c8211": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "skipSearch": false
    }],
    "cenaia-vecchia": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "98cb110c": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "skipSearch": false
    }],
    "collealberti": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f0d3d79": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "skipSearch": false
    }],
    "fungiaia": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e0e98f6": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "skipSearch": false
    }],
    "i-gioielli": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e0305f9": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "skipSearch": false
    }],
    "ii-colle": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a79d4459": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "skipSearch": false
    }],
    "la-capannina": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24de6340": [{
      "hkey": "b7c154e1",
      "slug": "i-greppioli-la-casa",
      "name": "I Greppioli-La Casa",
      "primary": true,
      "skipSearch": false
    }],
    "la-casa": [{
      "hkey": "b7c154e1",
      "slug": "i-greppioli-la-casa",
      "name": "I Greppioli-La Casa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "df46fc6b": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "skipSearch": false
    }],
    "la-fonte": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1444262b": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "skipSearch": false
    }],
    "la-tana": [{
      "hkey": "998e31dc",
      "slug": "crespina-lorenzana",
      "name": "Crespina Lorenzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "45e85d46": [{
      "hkey": "69c3c89d",
      "slug": "tripalle-botteghino",
      "name": "Tripalle-Botteghino",
      "primary": true,
      "skipSearch": false
    }],
    "tripalle": [{
      "hkey": "69c3c89d",
      "slug": "tripalle-botteghino",
      "name": "Tripalle-Botteghino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;